import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ArrangeableListInput from '../arrangeable-list-input/ArrangeableListInput';
import ArrangeableFilterInput from '../arrangeable-filter-input/ArrangeableFilterInput';
import ButtonInput from '../button-input/ButtonInput';
import ChartInput from '../chart-input/ChartInput';
import CheckboxInput from '../checkbox-input/CheckboxInput';
import CheckboxInputList from '../checkbox-input-list/CheckboxInputList';
import DateRangeFilterInput from '../date-range-filter-input/DateRangeFilterInput';
import FeaturedMediaInput from '../featured-media-input/FeaturedMediaInput';
import FilterInput from '../filter-input/FilterInput';
import GridInput from '../grid-input/GridInput';
import { Grid, GridItem } from '../grid/Grid';
import ImageInput from '../image-input/ImageInput';
import InputUpload from '../input-upload/InputUpload';
import LinkInput from '../link-input/LinkInput';
import RadioInputList from '../radio-input-list/RadioInputList';
import RichTextEditor from '../rich-text-editor/RichTextEditor';
import SelectBox from '../select-box/SelectBox';
import TextArea from '../text-area/TextArea';
import TextInput from '../text-input/TextInput';
import ToggleInput from '../toggle-input/ToggleInput';
import Typeahead from '../typeahead/Typeahead';
import VideoInput from '../video-input/VideoInput';
import classNames from 'classnames';
import './InputList.css';

export default class InputList extends Component {
  getValues = (passedInputs) => {
    let values = {};
    let errors = [];

    let inputs = (passedInputs) ?
      passedInputs :
      this.props.inputs;

    inputs.forEach((input, index) => {
      // For columnized input list
      if (input) {
        if (Array.isArray(input)) {
          let columnsValues = this.getValues(input);
          values = Object.assign(values, columnsValues.values);
          errors = [...errors, ...columnsValues.errors];
        }
        // For fieldset input list
        else if ('fieldsetLegend' in input) {
          let fieldsetValues = this.getValues(input.inputs);
          values = Object.assign(values, fieldsetValues.values);
          errors = [...errors, ...fieldsetValues.errors];
        }
        else if (input.type !== "button" && input.type !== "icon-button" && input.type !== "submit" && input.type !== "static") {
          try {
            values[input.id] = this[input.id].getValue();
          }
          catch (error) {
            values[input.id] = error.value;
            errors.push(error.message);
          }
        }
      }
    });

    return {
      id: this.props.formId,
      errors,
      values
    };
  }

  // Takes the input object and key's name and returns the input built out of it based on the type
  convertToElement = (input, keyName) => {
    keyName = input.key || keyName;

    switch (input.type) {
      case "text":
      case "password":
      case "search":
      case "number":
      case "date":
        return (
          <TextInput
            autoComplete={input.autoComplete}
            className={input.className}
            contentWrapperClass={input.contentWrapperClass}
            disabled={input.disabled}
            errorMessage={input.errorMessage}
            existingContent={input.existingContent}
            helperText={input.helperText}
            id={input.id}
            infoText={input.infoText}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            label={input.label}
            maxLength={input.maxLength}
            minLength={input.minLength}
            numberMax={input.numberMax}
            numberMin={input.numberMin}
            numberStep={input.numberStep}
            onBlur={input.onBlur}
            onChange={input.onChange}
            onKeyUp={input.onKeyUp}
            onSearch={input.onSearch}
            patternMatch={input.patternMatch}
            patternMatchError={input.patternMatchError}
            placeholderText={input.placeholderText}
            ref={instance => { this[input.id] = instance; }}
            required={input.required}
            requiredError={input.requiredError}
            trim={input.trim}
            type={input.type}
            validateOnBlur={input.validateOnBlur}
            validateOnChange={input.validateOnChange}
            validationErrorClass={input.validationErrorClass}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "toggle-input":
        return (
          <ToggleInput
            label={input.label}
            toggleVal={input.toggleVal}
            id={input.id}
            required={input.required}
            selectedId={input.selectedId}
            errorMessage={input.errorMessage}
            key={keyName}
            onChange={input.onChange}
            selectInputList={input.selectInputList}
            ref={instance => { this[input.id] = instance; }}
            radioProps={input.radioProps} />
        )
      case "arrangeable-list":
        return (
          <ArrangeableListInput
            id={input.id}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            options={input.options}
            ref={instance => { this[input.id] = instance; }}
            label={input.label}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "arrangeable-filter":
        return (
          <ArrangeableFilterInput
            existingContentArray={input.existingContentArray}
            id={input.id}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            options={input.options}
            ref={instance => { this[input.id] = instance; }}
            label={input.label}
            verticalSpacing={input.verticalSpacing}
            placeholderText={input.placeholderText}
          />
        );
      case "chart":
        return (
          <ChartInput
            existingContentObject={input.existingContentObject}
            id={input.id}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            label={input.label}
            ref={instance => { this[input.id] = instance; }}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "checkbox":
        return (
          <CheckboxInput
            className={input.className}
            checked={input.checked}
            checkboxWrapperClassName={input.checkboxWrapperClassName}
            disabled={input.disabled}
            errorMessage={input.errorMessage}
            id={input.id}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            label={input.label}
            legend={input.legend}
            name={input.name}
            onChange={input.onChange}
            ref={instance => { this[input.id] = instance; }}
            required={input.required}
            requiredFieldIndicatorStyle={input.requiredFieldIndicatorStyle}
            value={input.value}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "checkbox-list":
        return (
          <CheckboxInputList
            className={input.className}
            checkboxProps={input.checkboxProps}
            disabled={input.disabled}
            errorMessage={input.errorMessage}
            groupName={input.groupName}
            id={input.id}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            legend={input.legend}
            onChange={input.onChange}
            ref={instance => { this[input.id] = instance; }}
            required={input.required}
            requiredFieldIndicatorStyle={input.requiredFieldIndicatorStyle}
            selectedIds={input.selectedIds}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "grid":
        return (
          <GridInput
            id={input.id}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            label={input.label}
            ref={instance => { this[input.id] = instance; }}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "radio-list":
        return (
          <RadioInputList
            className={input.className}
            disabled={input.disabled}
            errorMessage={input.errorMessage}
            groupName={input.groupName}
            helperText={input.helperText}
            id={input.id}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            legend={input.legend}
            onChange={input.onChange}
            radioProps={input.radioProps}
            radioWrapperClassName={input.radioWrapperClassName}
            ref={instance => { this[input.id] = instance; }}
            required={input.required}
            selectedId={input.selectedId}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "select":
        return (
          <SelectBox
            className={input.className}
            disabled={input.disabled}
            errorMessage={input.errorMessage}
            existingContent={input.existingContent}
            helperText={input.helperText}
            id={input.id}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            label={input.label}
            onBlur={input.onBlur}
            onChange={input.onChange}
            options={input.options}
            ref={instance => { this[input.id] = instance; }}
            required={input.required}
            requiredError={input.requiredError}
            validateOnBlur={input.validateOnBlur}
            validationErrorClass={input.validationErrorClass}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "link":
        return (
          <LinkInput
            className={input.className}
            disabled={input.disabled}
            errorMessage={input.errorMessage}
            existingContentObject={input.existingContentObject}
            id={input.id}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            label={input.label}
            newWindow={input.newWindow}
            ref={instance => { this[input.id] = instance; }}
            required={input.required}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "image":
        return (
          <ImageInput
            className={input.className}
            disabled={input.disabled}
            existingContentObject={input.existingContentObject}
            id={input.id}
            hasGraphicCheckbox={input.hasGraphicCheckbox}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            label={input.label}
            ref={instance => { this[input.id] = instance; }}
            showInputsInReadOnly={input.showInputsInReadOnly}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "video":
        return (
          <VideoInput
            className={input.className}
            disabled={input.disabled}
            existingContentObject={input.existingContentObject}
            id={input.id}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            label={input.label}
            ref={instance => { this[input.id] = instance; }}
            showInputsInReadOnly={input.showInputsInReadOnly}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "featured-media":
        return (
          <FeaturedMediaInput
            className={input.className}
            errorMessage={input.errorMessage}
            existingContentObject={input.existingContentObject}
            id={input.id}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            label={input.label}
            ref={instance => { this[input.id] = instance; }}
            required={input.required}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "filter":
        return (
          <FilterInput
            alphabetize={input.alphabetize}
            className={input.className}
            errorMessage={input.errorMessage}
            existingContentArray={input.existingContentArray}
            returnsSingleOption={input.returnsSingleOption}
            filterValueChange={input.filterValueChange}
            id={input.id}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            label={input.label}
            options={input.options}
            onChange={input.onChange}
            placeholderText={input.placeholderText}
            ref={instance => { this[input.id] = instance; }}
            required={input.required}
            selectLimit={input.selectLimit}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "typeahead":
        return (
          <Typeahead
            alphabetize={input.alphabetize}
            className={input.className}
            errorMessage={input.errorMessage}
            existingContentArray={input.existingContentArray}
            filterValueChange={input.filterValueChange}
            hasListAllView={input.hasListAllView}
            id={input.id}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            label={input.label}
            options={input.options}
            onChange={input.onChange}
            placeholderText={input.placeholderText}
            ref={instance => { this[input.id] = instance; }}
            required={input.required}
          />
        );
      case "icon-button":
      case "button":
      case "submit":
        return (
          <ButtonInput
            className={input.className}
            key={keyName}
            icon={input.icon}
            index={input.index}
            disabled={input.disabled}
            errorMessage={input.errorMessage}
            link={input.link}
            internalLink={input.internalLink}
            onClick={input.onClick}
            newWindow={input.newWindow}
            ref={instance => { this[input.id] = instance; }}
            verticalSpacing={input.verticalSpacing}
            requireConfirmation={input.requireConfirmation}
            type={input.type}
            value={input.value}
          />
        );
      case "rich-text":
        return (
          <RichTextEditor
            key={keyName}
            errorMessage={input.errorMessage}
            existingContent={input.existingContent}
            id={input.id}
            isEditable={(!(input.isEditable === undefined)) ? input.isEditable : this.props.isEditable}
            label={input.label}
            onBlur={input.onBlur}
            ref={instance => { this[input.id] = instance; }}
            required={input.required}
            textDirection={input.textDirection}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "text-area":
        return (
          <TextArea
            className={input.className}
            contentWrapperClass={input.contentWrapperClass}
            disabled={input.disabled}
            errorMessage={input.errorMessage}
            existingContent={input.existingContent}
            id={input.id}
            isEditable={(!(input.isEditable === undefined)) ? input.isEditable : this.props.isEditable}
            key={keyName}
            label={input.label}
            helperText={input.helperText}
            maxLength={input.maxLength}
            minLength={input.minLength}
            name={input.name}
            onChange={input.onChange}
            placeholder={input.placeholderText}
            ref={instance => { this[input.id] = instance; }}
            required={input.required}
            requiredError={input.requiredError}
            useDiv={input.useDiv}
            verticalSpacing={input.verticalSpacing}
            validateOnBlur={input.validateOnBlur}
            validationErrorClass={input.validationErrorClass}
          />
        );
      case "input-upload":
        return (
          <InputUpload
            buttonLabel={input.buttonLabel}
            existingContent={input.existingContent}
            fileTypes={input.fileTypes}
            hasGrid={input.hasGrid}
            id={input.id}
            isEditable={(!(input.isEditable === undefined)) ? input.isEditable : this.props.isEditable}
            key={keyName}
            label={input.label}
            ref={instance => { this[input.id] = instance; }}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "date-range-filter":
        return (
          <DateRangeFilterInput
            className={input.className}
            disabled={input.disabled}
            existingContentObject={input.existingContentObject}
            id={input.id}
            isEditable={(input.isEditable !== undefined) ? input.isEditable : this.props.isEditable}
            key={keyName}
            label={input.label}
            options={input.options}
            filterValueChange={input.filterValueChange}
            ref={instance => { this[input.id] = instance; }}
            verticalSpacing={input.verticalSpacing}
          />
        );
      case "static":
        return (<React.Fragment key={keyName}>{input.content}</React.Fragment>);
      default:
        return null;
    }
  }

  // Takes a column of inputs and creates a GridItem containing the inputs from within that column.
  buildColumn = (column, index) => {
    return <GridItem key={index}>
      {
        column.reduce((inputElements, input, index) => {
          if (input) {
            // When the input object isn't a fieldset
            const isFieldset = ('fieldsetLegend' in input);

            if (!isFieldset) {
              inputElements.push(this.convertToElement(input, index));
            }

            // When the input object is a fieldset
            else {
              // Creates a fieldset and recursively calls handleInputs on the inputs field within it
              if (isFieldset) {
                const requiredFieldIndicator = input.required
                  ? <abbr title="This field is required"></abbr>
                  : null

                inputElements.push(
                  <fieldset key={index} className={input.className}>
                    { input.fieldsetLegend ? <legend>{requiredFieldIndicator}{requiredFieldIndicator ? " " : ""}{input.fieldsetLegend}</legend> : null }
                    <Grid columns={input.fieldsetColumns} isNestedGrid={true}>
                      {this.handleInputs(input.inputs)}
                    </Grid>
                  </fieldset>
                )
              }
            }
          }
          return inputElements;
        }, [])
      }
    </GridItem>;
  }

  // Builds columns for each column array in the input list data, or just one column if the data is not columnized
  handleInputs = (inputs) => {
    // When the content is provided as one column of objects so is not split into sub-arrays
    if (!Array.isArray(inputs[0])) {
      return this.buildColumn(inputs);
    }
    // When the content is provided as sub-arrays for columnizing
    else {
      return inputs.map((column, index) => {
        return this.buildColumn(column, index);
      });
    }
  }

  onSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    let fieldValues = this.getValues();

    this.props.onSubmit(fieldValues);
  }

  render() {
    let gridItemArray = this.handleInputs(this.props.inputs);

    let formClasses = classNames(
      'input-list',
      {
        'inline-list': this.props.isInlineList
      },
      this.props.className,
      this.props.verticalSpacing
    );

    let errorMessage = (this.props.errorMessage) ?
      <span className="error-message">
        {this.props.errorMessage}
      </span> :
      null;

    return (
      <form
        onSubmit={this.onSubmit}
        id={this.props.formId}
        className={formClasses}
      >
        <Grid columns={this.props.gridColumns} isNestedGrid={this.props.isNestedGrid}>
          {gridItemArray}
        </Grid>
        {errorMessage}
      </form>
    );
  }
}

InputList.defaultProps = {
  isEditable: true,
  isInlineList: false
};

InputList.propTypes = {
  className: PropTypes.string,
  formId: PropTypes.string,
  gridColumns: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  inputs: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)),
    PropTypes.arrayOf(PropTypes.object)
  ]).isRequired,
  errorMessage: PropTypes.string,
  isEditable: PropTypes.bool,
  isInlineList: PropTypes.bool,
  isNestedGrid: PropTypes.bool,
  onSubmit: PropTypes.func
}
